import { Actions } from './constants';

// (name: string, value: string, options: object) => object
export const setCookie = (name, value, options) => ({
  type: Actions.COOKIES_SET,
  payload: {
    name,
    value,
    options: {
      // httpOnly: a boolean indicating whether the cookie is only to be sent over HTTP(S)
      // and not made available to client JavaScript (true by default).
      httpOnly: false,
      ...options,
    },
  },
});

// (name: string) => object
export const getCookie = name => ({
  type: Actions.COOKIES_GET,
  payload: {
    name,
  },
});

// (name: string) => object
export const removeCookie = (name, options) => ({
  type: Actions.COOKIES_REMOVE,
  payload: {
    name,
    options,
  },
});

// (name: string) => object
export const expireCookie = name => ({
  type: Actions.COOKIES_EXPIRE,
  payload: {
    name,
  },
});
